import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    Chip,
    Stack,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export function RecipeCard({ recipe }: { recipe: any }) {
    const navigate = useNavigate();

    return (
        <Card
            variant="outlined"
            sx={(theme) => ({
                borderRadius: 1,
                overflow: "hidden",
                border: `1px solid ${theme.palette.brand.accent}`,
                bgcolor: theme.palette.background.paper,
                transition: "transform 140ms ease, box-shadow 140ms ease",
                "&:hover": {
                    transform: "translateY(-3px)",
                    boxShadow: theme.shadows[6],
                },
            })}
        >
            <CardActionArea onClick={() => navigate(`/recipes/${recipe.id}`)}>
                {/* Thumbnail */}
                <Box sx={{ position: "relative" }}>
                    <Box
                        component="img"
                        src={recipe.imageUrl || "/placeholder-recipe.jpg"}
                        alt={recipe.title}
                        loading="lazy"
                        sx={{
                            width: "100%",
                            height: 150,
                            objectFit: "cover",
                            display: "block",
                        }}
                    />

                    {/* Optional: overlay first category */}
                    {!!recipe.categoryNames?.length && (
                        <Chip
                            size="small"
                            label={recipe.categoryNames[0]}
                            sx={{
                                position: "absolute",
                                left: 10,
                                bottom: 10,
                                bgcolor: "rgba(0,0,0,0.55)",
                                color: "white",
                                backdropFilter: "blur(6px)",
                            }}
                        />
                    )}
                </Box>

                <CardContent sx={{ p: 2 }}>
                    <Typography
                        variant="subtitle1"
                        sx={(theme) => ({
                            color: theme.palette.text.primary,
                            fontWeight: 800,
                            lineHeight: 1.2,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                        })}
                    >
                        {recipe.title}
                    </Typography>

                    {recipe.shortDescription && (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                mt: 0.75,
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                            }}
                        >
                            {recipe.shortDescription}
                        </Typography>
                    )}

                    {!!recipe.categoryNames?.length && (
                        <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 1.5 }}>
                            {recipe.categoryNames.slice(0, 3).map((c: string) => (
                                <Chip
                                    key={c}
                                    label={c}
                                    size="small"
                                    variant="outlined"
                                    sx={(theme) => ({
                                        borderColor: theme.palette.brand.accent,
                                        color: theme.palette.text.primary,
                                        bgcolor:
                                            theme.palette.mode === "dark"
                                                ? "rgba(255,255,255,0.03)"
                                                : "rgba(0,0,0,0.02)",
                                    })}
                                />
                            ))}
                        </Stack>
                    )}
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
